// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__2PNww","hiddenTitle":"Grid_hiddenTitle__zTt13","gridImage":"Grid_gridImage__2l1Iw"};